// cr 選單
"use client";
import Image from "next/image";
import { CR_NAV } from "../common/constant";
import { goTo } from "../common/functions";

const CRMenuPop = ({ showCRMenu, dispatch, setCRMenu }) => {
  const footer = "Copyright © 2024 Crypto City All Rights Reserved";

  return (
    <div
      className={`fixed w-screen h-screen top-0 right-0 trans justify-end
            ${showCRMenu ? "z-[13]" : "z-[-1]"}`}
    >
      {/* 關閉用 */}
      <div
        className="absolute w-screen h-screen top-0 left-0 z-[0]"
        onClick={() => dispatch(setCRMenu(false))}
      />

      <div
        className={`trans absolute top-0 right-0 z-[1] h-full w-[238px] bg-red0 
                    px-[26px] py-[57px] noScrollY text-white flex flex-col items-center
                    ${!showCRMenu ? "translate-x-[240px]" : "translate-x-0"}`}
      >
        <div className="mx-auto max-h-[186px]">
          <Image
            alt="menu"
            width={186}
            height={45}
            className="aspect-[186/45]"
            src="/images/cryptoread/menu.svg"
          />
        </div>

        <ul className="h-auto flex flex-col gap-y-[22px] py-[38px]">
          {Object.values(CR_NAV).map((item, i) => {
            const title =
              item?.title === "PRIVACY POLICY" ? "PRIVACY" : item?.title;
            return (
              <li key={`${item?.title}_${i}`} className={`${(i > 0 && i < 4 )&& 'menu-link' }`}>
                <button
                  className="flex flex-nowrap items-center hover:opacity-[.5]"
                  rel="noreferrer noopener"
                  onClick={(e) => {
                    dispatch(setCRMenu(false));
                    if(i === 0 || i > 3)return window.location.href = item?.link;
                    goTo(e, item?.link);
                  }}
                >
                  <div className="w-[7px] h-[7px] bg-white mr-[16px]"></div>
                  <span>{title}</span>
                </button>
              </li>
            );
          })}
        </ul>

        <div className="text-bd3n text-center">
          <p>{footer}</p>
        </div>
      </div>
    </div>
  );
};

export default CRMenuPop;
